module.exports = __webpack_public_path__ + "img/tangOne_1.63f2b98d.png";